import { markerMode } from './_context.js';

export function createClusterRenderer() {
    const svg = window.btoa(clusterSVG);
    return {
        render: ({ count, position }) => {
            if (markerMode === 'advanced') {
                const container = document.createElement('div');
                container.style.position = 'relative';
                container.style.display = 'inline-flex';
                container.style.alignItems = 'center';
                container.style.justifyContent = 'center';
                const img = document.createElement('img');
                img.src = `data:image/svg+xml;base64,${svg}`;
                img.style.width = `${parseInt(clusterSize)}px`;
                img.style.height = `${parseInt(clusterSize)}px`;
                const label = document.createElement('span');
                label.textContent = String(count);
                label.style.position = 'absolute';
                label.style.top = '50%';
                label.style.left = '50%';
                label.style.transform = 'translate(-50%, -50%)';
                label.style.color = clusterNumberColor;
                label.style.fontSize = clusterNumberFontSize;
                label.style.fontWeight = clusterNumberFontWeight;
                label.style.fontFamily = clusterNumberFontFamily;
                container.appendChild(img);
                container.appendChild(label);
                return new google.maps.marker.AdvancedMarkerElement({
                    position,
                    content: container,
                    title: String(count) + ' ' + clusterText,
                    zIndex: 1073741823 + count,
                });
            }
            return new google.maps.Marker({
                position,
                title: String(count) + ' ' + clusterText,
                label: {
                    text: String(count),
                    color: clusterNumberColor,
                    fontSize: clusterNumberFontSize,
                    fontWeight: clusterNumberFontWeight,
                    fontFamily: clusterNumberFontFamily,
                },
                icon: {
                    url: `data:image/svg+xml;base64,${svg}`,
                    scaledSize: new google.maps.Size(parseInt(clusterSize), parseInt(clusterSize)),
                },
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
            });
        },
    };
}
